(function () {

    'use strict';

    var Experience = {
        $sections: $('.experience-section'),
        $toggleRSE: $('.rse-btn'),
        init: function () {
            this.setActiveSection();
            this.showFirstRSE();
            this.bindEvents();
        },
        bindEvents: function () {
            var self = this;
            $(window).on('scroll', function() {
                self.setActiveSection();
            });
            this.$toggleRSE.on('click', function(e) {
                e.preventDefault();
                var el = $(this).attr('href');
                if ($(el).length) {
                    self.showRSE(el);
                }
            });
        },
        setActiveSection: function () {
            var scrollTop = $(window).scrollTop(),
                offset;
            $.each(this.$sections, function() {
                offset = $(this).offset().top  + $(this).outerHeight() / 2 - $(window).height();
                $(this).toggleClass('active', scrollTop > offset);
            });
        },
        showFirstRSE: function () {
            var el = this.$toggleRSE.eq(0).attr('href');
            this.showRSE(el);
        },
        showRSE: function (el) {
            this.$toggleRSE
                .removeClass('active')
                .filter('[href="' + el + '"]').addClass('active')
            $(el).removeClass('d-none')
                .siblings('.rse-paragraph').addClass('d-none');
        }
    };
    Experience.init();

})(window);